import { render, staticRenderFns } from "./confirm_dialog_new_password.vue?vue&type=template&id=7fdaa5b2"
import script from "./confirm_dialog_new_password.vue?vue&type=script&lang=js"
export * from "./confirm_dialog_new_password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports